const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const VALIDATION_RULES = {
  email: EMAIL_REGEX,
} as const

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value)
}
